import { signal } from "@preact/signals-react";

export const patientsState = signal<Record<string, unknown>>({});
